
import { Controller } from "@hotwired/stimulus";

export default class SavedShowcaseSelectionController extends Controller {
  static targets = [
    "checkbox",
    "actions",
    "buyButton",
    "removeButton",
    "selectAll"
  ];

  connect() {
    this.refreshSelection();
  }

  checkboxTargetConnected() {
    this.refreshSelection();
  }

  checkboxTargetDisconnected() {
    this.refreshSelection();
  }

  toggle() {
    this.refreshSelection();
  }

  toggleAll() {
    for (const checkbox of this.checkboxTargets) {
      checkbox.checked = this.selectAllTarget.checked;
    }

    this.refreshSelection();
  }

  refreshSelection() {
    const checkboxes = this.checkboxTargets;
    const selectedCheckboxes = checkboxes.filter(
      (checkbox) => checkbox.checked
    );

    const hasSelection = selectedCheckboxes.length > 0;
    const allSelected =
      checkboxes.length > 0 &&
      selectedCheckboxes.length === checkboxes.length;

    if (this.hasActionsTarget) {
      this.actionsTarget.classList.toggle("d-none", !hasSelection);
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = allSelected;
      this.selectAllTarget.indeterminate =
        hasSelection && !allSelected;
    }

    if (this.hasBuyButtonTarget) {
      this.buyButtonTarget.disabled = !hasSelection;
    }

    if (this.hasRemoveButtonTarget) {
      this.removeButtonTarget.disabled = !hasSelection;
    }
  }

  selectedShowcaseNumbers() {
    return this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.dataset.showcaseNumber);
  }

  async buySelected() {
    const showcaseNumbers = this.selectedShowcaseNumbers();

    if (showcaseNumbers.length === 0) return;

    const turboRequest = await this.loadTurboRequest();

    turboRequest("/showcases/multiple_buy_now", {
      method: "POST",
      params: {
        showcase_ids: showcaseNumbers
      },
      turboStream: false,
      onSuccess: () => {
        const modalElement = document.getElementById(
          "shareRecipeScrollModal"
        );

        if (!modalElement) return;

        bootstrap.Modal.getOrCreateInstance(modalElement).show();
      }
    });
  }


  async removeSelected() {
    const showcaseNumbers = this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.dataset.savedShowcaseNumber);

    if (showcaseNumbers.length === 0) return;

    const turboRequest = await this.loadTurboRequest();

    turboRequest("/shopping_bags/remove_all_saved_showcases", {
      method: "DELETE",
      turboStream: true,
      params: {
        saved_showcase_ids: showcaseNumbers
      },
    });
  }


  async loadTurboRequest() {
    const { turboRequest } = await import("../helpers/api");
    return turboRequest;
  }
}
